import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { useGetPlantsQuery } from '@/features/plants/hooks/queries/use-get-plants.tsx';
import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import { useEffect, useMemo } from 'react';
import { usePlantsStore } from '@/services/store/use-plants-store.tsx';
import { useShallow } from 'zustand/react/shallow';
import { PlantProductionAndStorageOverviewBasic } from '@/features/plants/components/plant-overview/production-and-storage/basic/plant-production-and-storage-overview-basic.tsx';
import { PlantStatusBanner } from '@/features/plants/components/plant-overview/production-and-storage/plant-status-banner';

export const BasicDashboardPage = () => {
  const [selectedPlant, setSelectedPlant] = usePlantsStore(
    useShallow((state) => [state.selectedPlant, state.setSelectedPlant])
  );

  const { data: queryPlants } = useGetPlantsQuery();

  const oldestPlant = useMemo(() => {
    if (!queryPlants?.length) return undefined;
    return [...queryPlants].sort((a, b) => a.createdAt.localeCompare(b.createdAt))[0];
  }, [queryPlants]);

  useEffect(() => {
    if (oldestPlant && !selectedPlant) {
      setSelectedPlant(oldestPlant);
    }

    if (queryPlants?.length === 0 && selectedPlant) setSelectedPlant(undefined);
  }, [oldestPlant, queryPlants?.length]);

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">{selectedPlant?.basicDetails.name}</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <PlantStatusBanner status={selectedPlant?.basicDetails.status} />
          <PlantProductionAndStorageOverviewBasic plantId={selectedPlant?.plantId ?? ''} />
        </div>
      </div>
    </div>
  );
};
